import { joinUrlPath, sendPost } from '@eqs/cms-svelte-irtools/api';
import { API_REQUEST_URL, SUBSCRIPTION_CONFIRM_URL } from '../../../utils/constants';
export const validateSubscriptionToken = async (token) => {
    const requestUrl = `${API_REQUEST_URL}/${SUBSCRIPTION_CONFIRM_URL}`;
    const url = joinUrlPath(requestUrl, token);
    const response = await sendPost(url, {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/ld+json'
        }
    }).then(async (res) => {
        return (await res.json());
    });
    if (!!response.id === true) {
        return true;
    }
    throw new Error(response['hydra:description'] || response['detail']);
};
